import SidebarLayout from "../../../layouts/SidebarLayout";

export const LoadingPage = () => (
  <SidebarLayout>
    <></>
  </SidebarLayout>
)
